import {Typography} from '@mui/material';
import AurButton from '../../common/aur-button/AurButton';
import {ReactComponent as ExchangeIcon} from '../../../../src/assests/svg/icon_shift.svg';
import {t} from 'i18next';
import {useDispatch, useSelector} from 'react-redux';
import {openDialog} from '../../../redux/slices/reportsDialogSlice';
import ProjectWorkSpaceSelectionDialog from './WorkSpaceSummary/ProjectWorkSpaceSelectionDialog';
import ProjectWorkSpaceSelection from './WorkSpaceSummary/ProjectWorkSpaceSelection';
import {getUTCDateTimeForDisplay} from '../../../utils/utils';
import {RootState} from '../../../redux/store';

import AurHighlyConfidential from '../../common/aur-highly-confidential/AurHighlyConfidential';
import {AurLightTooltip} from '../../common/aur-light-tooltip/aur-light-tooltip';

interface HostingHeaderProps {
  refreshDate?: string | null;
  openFrom?: string;
}

const HostingUserSummaryReportHeader = (props: HostingHeaderProps) => {
  const {refreshDate, openFrom} = props;
  const dispatch = useDispatch();

  const {
    selectedProjectName: projectName,
    selectedWorkSpaceName: workSpaceName,
    currentProject: project,
  } = useSelector((state: RootState) => state.reports);

  const handleOpenDialog = () => {
    dispatch(openDialog());
  };

  return (
    <div className="hosting-summary-header">
      {project?.highlyConfidential && (
        <AurHighlyConfidential
          type="pill"
          showWarningText={true}
          className="highly-confidential-alert"
        />
      )}
      <div className="summary-heading">
        <Typography className="typo-text subhead3_size" component="h1">
          {projectName}
        </Typography>
      </div>
      <div className="hosting-summary-sub-title">
        <Typography className="typo-text display3_size title-section ">
          {workSpaceName}
        </Typography>
        <AurButton
          ariaLabel={`${t('reports.hostingUserSummary.project')} | ${t('reports.hostingUserSummary.workspace')}`}
          classNames="typo-text buttonMedium_size"
          onClick={handleOpenDialog}
          type="continue"
          size="Medium"
          startIcon={<ExchangeIcon aria-hidden="true" />}
        >
          {t('reports.hostingUserSummary.project')}{' '}
          <span className="color-button-divider"> | </span>
          {t('reports.hostingUserSummary.workspace')}
        </AurButton>
        <ProjectWorkSpaceSelectionDialog
          ContentComponent={ProjectWorkSpaceSelection}
          openFrom={openFrom}
        />
      </div>
      <div className="hosting-summary-date-section">
        <Typography className="typo-text body3_size">
          {t('reports.hostingUserSummary.data')}{' '}
          <AurLightTooltip title={t('common.yearMonthDate')}>
            <span className="typo-text label1_size hosting-summary-date-sub-section">
              {getUTCDateTimeForDisplay(refreshDate || '')}
            </span>
          </AurLightTooltip>
        </Typography>
        <Typography className="typo-text body3_size">
          {t('reports.hostingUserSummary.description')}
        </Typography>
      </div>
    </div>
  );
};

export default HostingUserSummaryReportHeader;
